<template>
    <div>
        <div class="row active-panel-block align-items-center m-0">
            <div class="active-panel-block_icon">
                <b-icon icon="grip-vertical" font-scale="2" class="text-secondary"></b-icon>
            </div>
            <div class="text-bold-size-13 active-panel-block_one">
                <span class="font-weight-bold text-uppercase"><i class="fas fa-info-circle text-orange mr-1"></i> Информация:</span>
                <span class="font-weight-light text-uppercase mr-2">{{ getStatusName() }}</span>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-12">
                <table class="table table-hover table-borderless table-fixed">
                <tbody>
                    <tr>
                        <td class="table-title-details">ID поставки</td>
                        <td>{{ detailedItem.id }}</td>
                    </tr>
                    <tr>
                        <td class="table-title-details">Информация</td>
                        <td>{{ getStatusName() }}</td>
                    </tr>
                    <tr>
                        <td class="table-title-details">Виды услуг</td>
                        <td>
                            <template v-if="detailedItem.selected_services.length > 0">
                                <div
                                    v-for="(item, index) in detailedItem.selected_services"
                                    :key="item.id"
                                >
                                    <i class="fas fa-genderless text-orange mr-1"></i>
                                    <span
                                        class="text-uppercase font-weight-bold sidebar-link"
                                        @click="openOrderSidebar('', '', {tab: item.id})"
                                    >{{ item.name }}</span><template v-if="index != detailedItem.selected_services.length - 1">, </template>
                                </div>
                            </template>
                            <template v-else>
                                Не заданы
                            </template>
                        </td>
                    </tr>
                    <tr>
                        <td class="table-title-details">Наименование компании</td>
                        <td>
                            <span v-if="detailedItem.company">{{ detailedItem.company.name }}</span>
                            <span v-else>Не задана</span>
                            /
                            <span>
                                {{ detailedItem.company ? detailedItem.company.inn : "ИНН пока не задан" }}
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td class="table-title-details">ТО менеджер компании</td>
                        <td>{{ getCompanyToManagerName() }}</td>
                    </tr>
                    <tr>
                        <td class="table-title-details">ТЭО менеджер компании</td>
                        <td>{{ getCompanyTeoManagerName() }}</td>
                    </tr>
                    <tr>
                        <td class="table-title-details">Общая оценка поставки</td>
                        <td v-if="detailedItem.order_score && detailedItem.order_score.score">
                            <span style="font-size: 18px;">{{ detailedItem.order_score.score }}</span><span style="font-size: 12px;">/10</span>
                            <b-button
                                v-if="detailedItem.order_score.user_id === currentUser.id"
                                size="sm"
                                class="btn btn-secondary ml-3"
                                @click="openScoreSidebar"
                            >Исправить</b-button>
                        </td>
                        <td v-else>
                            <b-button
                                size="sm"
                                class="btn btn-secondary"
                                @click="openScoreSidebar"
                            >Оценить поставку</b-button>
                        </td>
                    </tr>
                    <tr v-if="detailedItem.order_score && detailedItem.order_score.score">
                        <td class="table-title-details">Комментарий к оценке поставки</td>
                        <td v-if="detailedItem.order_score">
                            <div v-if="parsedDescription">
                                <p class="mb-0"><strong>Качество обслуживания:</strong> 
                                    <span style="font-size: 18px;">{{ parsedDescription.kachestvo_obslugivaniya }}</span><span style="font-size: 12px;">/10</span></p>
                                <p class="mb-0"><strong>Скорость работы:</strong>
                                    <span style="font-size: 18px;">{{ parsedDescription.skorost_raboty }}</span><span style="font-size: 12px;">/10</span></p>
                                <p class="mb-0"><strong>Профессионализм и компетентность:</strong>
                                    <span style="font-size: 18px;">{{ parsedDescription.prof_and_comp_sotrudnikov }}</span><span style="font-size: 12px;">/10</span></p>
                                <p class="mt-1"><strong>Комментарий:</strong> {{ parsedDescription.description ? parsedDescription.description: 'Без комментария' }}</p>
                            </div>
                        </td>
                        <td v-else>Комментарий не оставлен</td>
                    </tr>
                </tbody>
                </table>
            </div>
        </div>

        <OrderScoreSidebar
            :isSidebarOpenScore="isSidebarOpenScore"
            :scoreText="detailedItem.order_score && detailedItem.order_score.description ? detailedItem.order_score.description : ''"
            :tempScoreOrderId="detailedItem.id"
            :stars="detailedItem.order_score && detailedItem.order_score.score ? detailedItem.order_score.score : 0"
            @update:isSidebarOpenScore="value => isSidebarOpenScore = value"
            @closeScoreSidebar="closeScoreSidebar"
            @saveOrderScore="saveOrderScore"
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { openOrderSidebar } from '@/mixins/openOrderSidebar';
import { API_COMMENTS, API_POST_ORDERS_SUBSTATUS_CREATE, API_DELETE_ORDERS_SUBSTATUS_DELETE } from '@/constants';
import MakeACall from '../phone/MakeACall.vue';
import OrderScoreSidebar from '@/components/orders/OrderScoreSidebar.vue';

export default {
    components: {
        MakeACall,
        OrderScoreSidebar,
    },
    
    props: {
        detailedItemIndex: { type: Number, required: false, default: 0 },
        detailedItem: { type: Object, required: true },
    },
    mixins: [
        openOrderSidebar
    ],
    data() {
        return {
            apiComments: API_COMMENTS,
            isSidebarOpenScore: false,
            parsedDescription: null,
        }
    },
    computed: {
        ...mapGetters("auth", ["currentUser"]),
        quotationPending() {
            return [359, 539, 540, 541, 542].includes(this.detailedItem.reference_status_id);
        },
    },
    watch: {
        'detailedItem.order_score.description': {
            handler(newValue) {
                this.parseDescription(newValue);
            },
            immediate: true,
        }
    },
    methods: {
        parseDescription(description) {
            try {
                this.parsedDescription = description ? JSON.parse(description) : null;
            } catch (e) {
                console.error("Error parsing description JSON:", e);
                this.parsedDescription = null;
            }
        },
        getSalesManagerName() {
            let name = "Не известен"
            if (this.detailedItem.company && this.detailedItem.company.sales_manager) {
                name = this.detailedItem.company.sales_manager.name
            }
            // if we have sales manager on one order
            if (this.detailedItem.optional_sales_manager && this.detailedItem.optional_sales_manager.name) {
                name = this.detailedItem.optional_sales_manager.name
            }
            return name
        },
        getCompanySalesManagerName() {
            let name = "Не известен"
            if (this.detailedItem.company && this.detailedItem.company.sales_manager) {
                name = this.detailedItem.company.sales_manager.name
            }
            return name
        },
        getCompanyToManagerName() {
            let name = "Не известен"
            if (this.detailedItem.company && this.detailedItem.company.to_manager) {
                name = this.detailedItem.company.to_manager.name
            }
            return name
        },
        getCompanyTeoManagerName() {
            let name = "Не известен"
            if (this.detailedItem.company && this.detailedItem.company.teo_manager) {
                name = this.detailedItem.company.teo_manager.name
            }
            return name
        },
        getStatusName() {
            if (this.quotationPending) {
                return "Формируем предложение и готовим коммерческое предложение"
            }
            let name = "Не известен"
            if (this.detailedItem.status && this.detailedItem.status.name) {
                name = this.detailedItem.status.name
            }
            return name
        },
        getCloseReason() {
            let name = ''
            if (this.detailedItem.close_reason && this.detailedItem.close_reason.name) {
                name = this.detailedItem.close_reason.name.replace(/\s*\(.*\)/,'')
            }

            return name
        },
        issetSmthOfTOInOrder() {
            let issetSmthOfTO = false

            if (this.detailedItem.selected_services) {
                this.detailedItem.selected_services.forEach((service) => {
                    // Если есть что-то кроме логистики
                    if (service.id !== 23) {
                        issetSmthOfTO = true
                    }
                })
            }

            return issetSmthOfTO
        },
        issetLogisticsInOrder() {
            let issetLogistic = false

            if (this.detailedItem.selected_services) {
                this.detailedItem.selected_services.forEach((service) => {
                    // Если есть ТЭО (Логистика)
                    if (service.id === 23) {
                        issetLogistic = true
                    }
                })
            }

            return issetLogistic
        },
        isSubstatus(reference_substatus_id) {
            let result = false
            this.detailedItem.order_substatuses.forEach((substatus) => {
                if (reference_substatus_id == substatus.reference_substatus_id) {
                    result = true
                }
            })

            return result
        },
        orderSubstatusCreate(reference_substatus_id) {
            let order_id = this.detailedItem.id
            this.dataOverlay = true
            api.call('post', `${API_POST_ORDERS_SUBSTATUS_CREATE}/${order_id}/${reference_substatus_id}`)
                .then(({data}) => {
                    this.detailedItem.order_substatuses.push(data)
                    // this.$emit('fullOrderUpdate')
                    this.dataOverlay = false
                })
        },
        orderSubstatusDelete(reference_substatus_id, index) {
            this.dataOverlay = true;
            api.call('delete', `${API_DELETE_ORDERS_SUBSTATUS_DELETE}/${reference_substatus_id}`)
                .then(() => {
                    this.detailedItem.order_substatuses.splice(index, 1);
                    this.dataOverlay = false;
                })
        },
        openScoreSidebar() {
            this.isSidebarOpenScore = true;
        },
        closeScoreSidebar() {
            this.isSidebarOpenScore = false;
        },
        saveOrderScore(score, text) {
            if (this.detailedItem.order_score) {
                this.updateOrderScore(score, text)
            } else {
                axios
                    .post('/api/order-scores', {
                        order_id: this.detailedItem.id,
                        user_id: this.currentUser.id,
                        score: score,
                        description: text
                    })
                    .then(data => {
                        this.detailedItem.order_score = data.data;
                        this.$emit('changeOrderScore', data.data);
                        this.closeScoreSidebar()
                    })
                    .catch(er => {
                        console.log(er);
                        this.closeScoreSidebar();
                    })
            }
        },
        updateOrderScore(score, text) {
            axios
                .put(`/api/order-scores/${this.detailedItem.order_score.id}`, {
                    order_id: this.detailedItem.id,
                    user_id: this.currentUser.id,
                    score: score,
                    description: text
                })
                .then(data => {
                    this.detailedItem.order_score = data.data;
                    this.$emit('changeOrderScore', data.data);
                    this.closeScoreSidebar()
                })
                .catch(er => {
                    console.log(er);
                    this.closeScoreSidebar();
                })
        },
    }
}
</script>
